import { ReactNode, FC } from "react";

// Define ProductCard as a function component with subcomponents
const ProductCard: FC<{ children: ReactNode }> & {
  Icon: FC<{ url: string }>;
  Content: FC<{ children: ReactNode }>;
  Title: FC<{ children: ReactNode }>;
  Subtitle: FC<{ children: ReactNode }>;
} = ({ children, ...rest }) => {
  return (
    <div className="rounded-lg border overflow-hidden pt-10 h-full w-full shadow" {...rest}>
      {children}
    </div>
  );
};

// Set the display name for the main component
ProductCard.displayName = "ProductCard";

// Define and add the subcomponents
ProductCard.Icon = ({ url }) => {
  return (
    <div
      style={{
        backgroundImage: `url(${url})`,
      }}
      className="bg-center bg-cover h-20 w-20 mx-auto"
    ></div>
  );
};
ProductCard.Icon.displayName = "ProductCard.Icon";

ProductCard.Content = ({ children }) => {
  return <div className="p-5 space-y-5">{children}</div>;
};
ProductCard.Content.displayName = "ProductCard.Content";

ProductCard.Title = ({ children }) => {
  return <h3 className="text-lg font-bold text-center">{children}</h3>;
};
ProductCard.Title.displayName = "ProductCard.Title";

ProductCard.Subtitle = ({ children }) => {
  return <p className="text-sm text-center">{children}</p>;
};
ProductCard.Subtitle.displayName = "ProductCard.Subtitle";

export default ProductCard;
